import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SaleService } from 'src/app/service/sale.service';
import { ProductSold } from '../sale/productSold';
import { Sale } from '../sale/sale';

@Component({
  selector: 'app-diolog-historico-cliente',
  templateUrl: './diolog-historico-cliente.component.html',
  styleUrls: ['./diolog-historico-cliente.component.scss']
})
export class DiologHistoricoClienteComponent {

  sales: Sale[] = [];

  ordemColunasTabela = ['id', 'createdAt','payment','products', 'amount'];

  constructor(
    public dialogRef: MatDialogRef<DiologHistoricoClienteComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private saleService: SaleService) {
      this.historicoClient(data.id); 
    }

  ngOnInit(): void {
  }

  historicoClient(id: number) {
    this.saleService.historicoCliente(id).subscribe((response) => {
      this.sales = response;
    });
  }



}
